import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom'; 
import './Navbar.css';

const Navbar = () => {

    const navigate = useNavigate(); 
    const [isDarkMode, setIsDarkMode] = useState(false);
        
          useEffect(() => {
            const checkDarkMode = () => {
              setIsDarkMode(document.body.classList.contains("dark-mode-body"));
            };
        
            checkDarkMode();
        
            const observer = new MutationObserver(checkDarkMode);
            observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
        
            return () => observer.disconnect(); 
          }, []);
    const location = useLocation(); 
    const fullNameMap = {
        'home': 'Home',
        'about-us': 'About Us',
        'products': 'Products',
        'field-crops': 'Field Crops',
        'vegetables': 'Vegetables',
        'rabi-crops-Vegetables': 'Rabi Crops Vegetables',
        'kharif-crops-Vegetables': 'Kharif Crops Vegetables',
        'rabi-crops': 'Rabi Crops',
        'kharif-crops': 'Kharif Crops',
        'production': 'Production',
        'stages': 'Stages of Production',
        'seed-production': 'Seed Production',
        'seed-processing': 'Seed Processing',
        'incentives': 'Incentives/Facilities to Growers',
        'marketing': 'Marketing',
        'rabi-seeds': 'Sale Rate of Rabi Crops - Seeds',
        'rabi-vegetables': 'Sale Rate of Rabi Crops - Vegetables',
        'kharif-seeds': 'Sale Rate of Kharif Crops - Seeds',
        'kharif-vegetables': 'Sale Rate of Kharif Crops - Vegetables',
        'rabi-availability': 'Availability of Rabi Seeds',
        'kharif-availability': 'Availability of Kharif Seeds',
        'offices': 'Regional Offices',
        'sale-counters': 'List of Sale Counters',
        'sale-rate-agro': 'Sale Rate of Agro Chemicals/Pesticides/Weedicides/Insecticides',
        'citizen-services':'Details of Citizen Services Delivered by the Organization',
        'subsidy-program': 'Manner of Execution of Subsidy Programme',
        'seeds-allocation': 'Allocation of Wheat, Gram, Mustard and Barley Seeds for Sale during Rabi 2022-23 season',
        'engineering': 'Engineering',
        'directory': 'Directory',
        'finance': 'Finance',
        'tenders': 'Tenders',
        'archived':'Archived',
        'administration': 'Administration',
        'service-rules': 'Service Rules',
        'circulars': 'Circulars',
        'forms': 'Forms and Procedures',
        'manuals': 'Purchase Manuals',
        'notifications': 'Notifications and Orders',
        'placement': 'Placement Announcements',
        'policies': 'Policies',
        'transfers': 'Transfers & Promotions',
        'miscellaneous': 'Miscellaneous',
        'anti-stubble-buring-campaign': 'Anti Stubble Buring Campaign',
        'contact-us': 'Contact Us',
        'directors': 'Directors',
        'head-offices': 'Head Offices',
        'regional-offices': 'Regional Offices',
        'screen-access-reader': 'Screen Access Reader',
        'internal-complaint-committee': 'Internal Complaint Committee',
        'audit-cell': 'Audit Cell',
        'quality-control': 'Quality Control',
        'agreements': 'Grower Agreements',
        'services': 'Services',
        'application-form': 'Application Form',
        'list-of-authorities': 'List of Authorities',
        'fees': 'Fees',
        'rti-replies': 'RTI Replies',
        'proactive-disclouser': 'Proactive Disclouser',
        'latest-news': 'Latest News',
    };

    const getReadablePath = (pathname) => {
        const pathSegments = pathname.split('/').filter(segment => segment);
        if (pathname === "/administration") {
            navigate("/administration/service-rules");
            return null; 
        }

        if (pathname === "/marketing") {
            navigate("/marketing/rabi-seeds");
            return null; 
        }
        if (pathname === "/products") {
            navigate("/products/field-crops");
            return null; 
        }
        if (pathname === "/directory") {
            navigate("/directory/directors");
            return null; 
        }
        if (pathname === "/production") {
            navigate("/production/stages");
            return null; 
        }


        let pathAccumulator = '';
    
        const breadcrumbLinks = pathSegments.map((segment, index) => {
            pathAccumulator += `/${segment}`;
            const readableName = fullNameMap[segment] || segment
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
    
            return (
                <React.Fragment key={index}>
                    <NavLink to={pathAccumulator} className={`breadcrumb-link ${isDarkMode ? "dark-mode-body" : "text-dark"}`}>
                        {readableName}
                    </NavLink>
                    {index < pathSegments.length - 1 && <span className="mx-1">»</span>}
                </React.Fragment>
            );
        });
    
        return (
            <>
                <NavLink to="/" className={`breadcrumb-link ${isDarkMode ? "dark-mode-body" : "text-dark"}`}>Home</NavLink>
                {pathSegments.length > 0 && <span className="mx-1">»</span>}
                {breadcrumbLinks}
            </>
        );
    };
    
     const closeDropdowns = () => {
        const dropdowns = document.querySelectorAll('.dropdown-menu');
        dropdowns.forEach((dropdown) => {
            dropdown.classList.remove('show');
        });
    };

    const closeNavbarOnMobile = () => {
        const navbarToggle = document.getElementById('navbarNav');
        if (navbarToggle.classList.contains('show')) {
            navbarToggle.classList.remove('show');
        }
    };

    useEffect(() => {
        const dropdownLinks = document.querySelectorAll('.dropdown-item');
        dropdownLinks.forEach((link) => {
            link.addEventListener('click', closeDropdowns);
        });

        const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
        navLinks.forEach((link) => {
            link.addEventListener('click', closeNavbarOnMobile);
        });

        return () => {
            dropdownLinks.forEach((link) => {
                link.removeEventListener('click', closeDropdowns);
            });

            navLinks.forEach((link) => {
                link.removeEventListener('click', closeNavbarOnMobile);
            });
        };
    }, []);

    useEffect(() => {
        const productionNavLink = document.getElementById('navbarDropdownProduction');
        const productsNavLink = document.getElementById('navbarDropdown');
        const marketingNavLink = document.getElementById('navbarDropdownMarketing');
        const directoryNavLink = document.getElementById('navbarDropdownDirectory');
        const adminNavLink = document.getElementById('navbarDropdownAdmin');

        if (adminNavLink) {
            adminNavLink.addEventListener('click', (event) => {
                event.preventDefault(); 
                window.open('/administration/service-rules', '_blank'); 
            });
        }
        if (directoryNavLink) {
            directoryNavLink.addEventListener('click', (event) => {
                event.preventDefault(); 
                window.open('/directory/directors', '_blank'); 
            });
        }
        if (marketingNavLink) {
            marketingNavLink.addEventListener('click', (event) => {
                event.preventDefault(); 
                window.open('/marketing/rabi-seeds', '_blank');
            });
        }
        if (productsNavLink) {
            productsNavLink.addEventListener('click', (event) => {
                event.preventDefault(); 
                window.open('/products/field-crops', '_blank'); 
            });
        }
        if (productionNavLink) {
            productionNavLink.addEventListener('click', (event) => {
                event.preventDefault(); 
                window.open('/production/stages', '_blank');
            });
        }

        return () => {
            if (productionNavLink) {
                productionNavLink.removeEventListener('click', () => {});
            }
            if (productsNavLink) {
                productsNavLink.removeEventListener('click', () => {});
            }
            if (marketingNavLink) {
                marketingNavLink.removeEventListener('click', () => {});
            }
            if (directoryNavLink) {
                directoryNavLink.removeEventListener('click', () => {});
            }
            if (adminNavLink) {
                adminNavLink.removeEventListener('click', () => {});
            }
        };
    }, [navigate]);


    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark bg-success" style={{ padding: '0' }}>
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav d-flex justify-content-between w-100">
                            <li className="nav-item">
                                <NavLink to="/" className="nav-link" end>HOME</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/about-us" className="nav-link">ABOUT US</NavLink>
                            </li>

                        
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link dropdown-toggle" to="/products/field-crops" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    PRODUCTS
                                </NavLink>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><NavLink target='_blank' to="/products/field-crops" className="dropdown-item">Field Crops</NavLink></li>
                                    <li><NavLink target='_blank' to="/products/vegetables" className="dropdown-item">Vegetables</NavLink></li>
                                </ul>
                            </li>

                            <li className="nav-item dropdown">
                                <NavLink className="nav-link dropdown-toggle" to="/production/stages" id="navbarDropdownProduction" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    PRODUCTION
                                </NavLink>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdownProduction">
                                    <li><NavLink target='_blank' to="/production/stages" className="dropdown-item">Stages of Production</NavLink></li>
                                    <li><NavLink target='_blank' to="/production/seed-production" className="dropdown-item">Seed Production</NavLink></li>
                                    <li><NavLink target='_blank' to="/production/seed-processing" className="dropdown-item">Seed Processing</NavLink></li>
                                    <li><NavLink target='_blank' to="/production/incentives" className="dropdown-item">Incentives/Facilities to Growers</NavLink></li>
                                </ul>
                            </li>

                          
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link dropdown-toggle" to="/marketing/rabi-seeds" id="navbarDropdownMarketing" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    MARKETING
                                </NavLink>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdownMarketing">
                                    <li><NavLink target='_blank' to="/marketing/rabi-seeds" className="dropdown-item">Sale Rate of Rabi Seeds - Crops</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/rabi-vegetables" className="dropdown-item">Sale Rate of Rabi Seeds - Vegetables</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/kharif-seeds" className="dropdown-item">Sale Rate of Kharif Seeds - Crops</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/kharif-vegetables" className="dropdown-item">Sale Rate of Kharif Seeds - Vegetables</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/rabi-availability" className="dropdown-item">Availability of Rabi Seeds</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/kharif-availability" className="dropdown-item">Availability of Kharif Seeds</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/offices" className="dropdown-item">Regional Offices</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/sale-counters" className="dropdown-item">List of Sale Counters</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/sale-rate-agro" className="dropdown-item">Sale Rate of Agro Chemicals/Pesticides/Weedicides/Insecticides</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/citizen-services" className="dropdown-item">Details of Citizen Services Delivered by the Organization</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/subsidy-program" className="dropdown-item">Manner of Execution of Subsidy Programme</NavLink></li>
                                    <li><NavLink target='_blank' to="/marketing/seeds-allocation" className="dropdown-item">Allocation of Wheat, Gram, Mustard and Barley Seeds for Sale during Rabi 2022-23 season</NavLink></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/engineering" className="nav-link">ENGINEERING</NavLink>
                            </li>
                           

                            <li className="nav-item dropdown">
                                <NavLink className="nav-link dropdown-toggle" to="/directory/directors" id="navbarDropdownDirectory" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                DIRECTORY
                                </NavLink>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdownDirectory">
                                    <li><NavLink target='_blank' to="/directory/directors" className="dropdown-item">Directors</NavLink></li>
                                    <li><NavLink target='_blank' to="/directory/head-offices" className="dropdown-item">Head Offices</NavLink></li>
                                    <li><NavLink target='_blank' to="/directory/regional-offices" className="dropdown-item">Regional Offices</NavLink></li>
                                   
                                </ul>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/finance" className="nav-link">FINANCE</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/tenders" className="nav-link">TENDERS</NavLink>
                            </li>

                          
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link dropdown-toggle" to="/administration/service-rules" id="navbarDropdownAdmin" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    ADMINISTRATION
                                </NavLink>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdownAdmin">
                                    <li><NavLink target='_blank' to="/administration/service-rules" className="dropdown-item">Service Rules</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/circulars" className="dropdown-item">Circulars</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/forms" className="dropdown-item">Forms and Procedures</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/manuals" className="dropdown-item">Purchase Manuals</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/notifications" className="dropdown-item">Notifications and Orders</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/placement" className="dropdown-item">Placement Announcements</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/policies" className="dropdown-item">Policies</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/transfers" className="dropdown-item">Transfers and Promotions</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/miscellaneous"
                                     className="dropdown-item">Miscellaneous</NavLink></li>
                                    <li><NavLink target='_blank' to="/administration/anti-stubble-buring-campaign" className="dropdown-item">Anti Stubble Buring Campaign</NavLink></li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/contact-us" className="nav-link">CONTACT US</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            
            <div className={`py-2 ${isDarkMode ? "dark-mode-body" : "bg-light"}`} style={{ paddingLeft: '15px' }}>
                <h6 className="mb-0">{getReadablePath(location.pathname)}</h6>
            </div>
        </>
    );
};

export default Navbar;
